<template>
  <div class="app-page__container app-page__container--no-sidebar">
    <div v-if="!isLoading">
      <h5 class="title is-5">
        Workspace Settings
      </h5>
      <div class="card">
        <div class="card-content">
          <p class="has-text-grey-light has-text-weight-bold">
            <b-icon icon="information" size="is-small" />&nbsp;General
          </p>
          <hr class="u-m-t-small">
          <p>
            <span class="is-size-5 has-text-weight-bold u-m-r-small">{{ activeWorkspace.userCount }}</span>
            <span class="has-text-grey">Active User{{ activeWorkspace.userCount > 1 ? 's' : '' }}</span>
          </p>
          <p>
            <span class="is-size-5 has-text-weight-bold u-m-r-small">{{ pendingInvitations.length || 0 }}</span>
            <span class="has-text-grey">Pending Invitation{{ Object.keys(pendingInvitations).length === 1 ? '' : 's' }}</span>
          </p>
        </div>
        <div class="card-content">
          <p class="has-text-grey-light has-text-weight-bold">
            <b-icon icon="information" size="is-small" />&nbsp;Options
          </p>
          <hr class="u-m-t-small">
          <p>
            <b-switch v-model="promptForGoalExplanationPreference">
              Prompt for an optional explanation when marking a goal as missed or changed.
            </b-switch>
          </p>
        </div>
        <div class="card-content">
          <p class="has-text-grey-light has-text-weight-bold">
            <b-icon icon="flash" size="is-small" />&nbsp;Billing
          </p>
          <hr class="u-m-t-small">
          <h5 class="title is-5">
            {{ subscriptionDetails.name}}
          </h5>
          <p class="subtitle is-size-6">
            {{ subscriptionDetails.description }}
          </p>
          <div class="content">
            <ul>
              <li
                v-for="planDetail in subscriptionDetails.planDetails"
                :key="planDetail.key"
              >
                {{ planDetail }}
              </li>
            </ul>
          </div>
          <p>
            You're currently being billed
            <span class="has-text-weight-bold">${{ subscriptionDetails.pricePerUser * activeWorkspace.userCount }}</span>
            per month
          </p>
        </div>
      </div>
    </div>
    <div v-else style="position: relative; min-height: 150px;">
      <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import * as SubscriptionTypes from '@/constants/Subscription.types';
import * as InvitationActions from '@/store/actions/Invitation.actions';
import * as WorkspaceActions from '@/store/actions/Workspace.actions';

export default {
  name: 'WorkspaceSettingsView',

  data() {
    return {
      isLoading: true,
    };
  },

  computed: {
    ...mapGetters([
      'activeWorkspaceSubscription',
      'activeWorkspace',
      'pendingInvitations',
    ]),
    ...mapState({
      loggedInUserId: state => state.auth.loggedInUserId,
      activeWorkspaceId: state => state.workspace.activeWorkspaceId,
    }),
    subscriptionDetails() {
      if (this.activeWorkspaceSubscription.stripePricingPlan === SubscriptionTypes.STRIPE_PRICE_TYPE_FREE_FOREVER(this.$env)) {
        return {
          name: 'Free Forever Plan',
          description: 'For small startups, students and hobbyists.',
          planDetails: [
            'All StandupPro features',
            'Up to 5 users',
          ],
          pricePerUser: 0,
          maxUsers: 5,
        };
      }

      return {
        name: 'Growth',
        description: 'For growing businesses with 6 or more users.',
        planDetails: [
          'All StandupPro features',
          '$5 per user per month',
        ],
        pricePerUser: 5,
        maxUsers: -1,
      };
    },
    promptForGoalExplanationPreference: {
      set(newVal) {
        const updateWorkspacePayload = {
          workspaceId: this.activeWorkspaceId,
          updatedWorkspace: {
            promptForGoalExplanationPreference: newVal,
          },
        };

        this.updateWorkspace(updateWorkspacePayload)
          .then(() => {
          })
          .catch(() => {
          });
      },
      get() {
        return this.activeWorkspace.promptForGoalExplanationPreference;
      },
    },
  },

  created() {
    this.fetchInitialData();
  },

  methods: {
    ...mapActions({
      fetchPendingWorkspaceInvitations: InvitationActions.FETCH_PENDING_WORKSPACE_INVITATIONS,
      updateWorkspace: WorkspaceActions.UPDATE_WORKSPACE_BY_ID,
    }),
    async fetchInitialData() {
      this.isLoading = true;
      await this.fetchPendingWorkspaceInvitations({ workspaceId: this.activeWorkspace.id });
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
